import React from 'react';
import './CustomQuestionRow.scss';
import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';
import { Tooltip } from 'primereact/tooltip';
import { useTranslation } from 'react-i18next';

interface CustomQuestionRowProps {
  isChecked: boolean;
  isDisabled: boolean;
  value: string;
  index: number;
  onCheckboxChange: (index: number, isChecked: boolean) => void;
  onQuestionChange: (index: number, value: string) => void;
  searchVolume: string;
  hasSearchVolumeData: boolean;
  isSearchVolumeLoading: boolean;
  canShowPhrase: boolean;
  phrase: string | null;
}

const CustomQuestionRow: React.FC<CustomQuestionRowProps> = ({
  isChecked,
  isDisabled,
  value,
  index,
  onCheckboxChange,
  onQuestionChange,
  searchVolume,
  hasSearchVolumeData,
  canShowPhrase,
  phrase,
  isSearchVolumeLoading,
}) => {
  const { t } = useTranslation();

  return (
    <div className={`custom-question ${hasSearchVolumeData ? 'custom-question--second' : ''}`}>
      <div className={`custom-question__row ${isDisabled ? 'custom-question__row--disabled' : ''}`}>
        <Checkbox
          id={`checkbox-question-${index}`}
          inputId={`custom-question-${index}`}
          onChange={(e) => onCheckboxChange(index, e.checked || false)}
          checked={isChecked}
          disabled={isDisabled}
        />
        <InputText
          placeholder={`${t('customQuestion')} ${index + 1}`}
          value={value}
          disabled={isDisabled}
          onChange={(e) => onQuestionChange(index, e.target.value)}
        />
      </div>
      {hasSearchVolumeData && <span className="custom-question__search-volume">{searchVolume}</span>}
      {canShowPhrase && phrase && phrase.trim() !== '' && (
        <span className="custom-question__phrase">{phrase}</span>
      )}
      {isSearchVolumeLoading && <span className="ico--loader ico--xs" />}
      {isDisabled && (
        <Tooltip
          target={`#checkbox-question-${index}`}
          content={t('limitRestriction')}
          className="tooltip--top"
          position="top"
          style={{ width: '220px' }}
          showDelay={5}
        />
      )}
    </div>
  );
};

export default CustomQuestionRow;
